import React from 'react'
import styled from 'styled-components'
import { Formik, Field } from 'formik'
import { Flex, Box, Container } from '../../ui/Layout.js'
import { space } from 'styled-system'
import formikFormWrapper from '../../formikFormWrapper.js'
import { Input, TextArea } from '../../ui/Input.js'
import { H1, H2, H3, H6, Label, Text, Span, GradientFont, Error, SmallTitle } from '../../ui/Typography.js'
import { BUTTON_STYLES, PLAY_BUTTON_STYLES, widgetPlayButtonPositionOptions, widgetPlayButtonSizeOptions } from '../types.js'
import ColorPicker, { ColorPickerRow } from '../../ui/ColorPicker.js'
import { getChevronStyling, getChevronImg, getChevronImgSize } from '../chevronStyles.js'
import { SideSelect } from '../../ui/Select.js'
import ToggleRedGreen from '../../ui/ToggleRedGreen.js'
const baseUrl = 'https://widget-v2.getclipara.com'

const FormInput = formikFormWrapper(Input)

const PlayButton = styled.svg``

const PlayButtonStyle = ({ values, setFieldValue, hidePosition, showShare, showNewPlayButtonTypes, showPlayButtonSize }) => {
  return (
    <Flex flexDirection="column" borderTop="1px solid rgba(237, 242, 247, 1)" pt="16px">
      <Label px="24px" mb="0px">
        Play Button Style
      </Label>
      <Flex flexWrap="wrap" mb="16px" px="24px">
        {Object.keys(PLAY_BUTTON_STYLES).map((style, i) => {
          const isSelected = values.widget.widgetPlayButtonStyle === style
          if ((style === PLAY_BUTTON_STYLES.DURATION || style === PLAY_BUTTON_STYLES.BOX) && !showNewPlayButtonTypes) {
            return null
          }
          return (
            <Flex
              boxSizing="border-box"
              cursor="pointer"
              justifyContent="center"
              alignItems="center"
              mt="8px"
              borderRadius="8px"
              width="167px"
              height="125px"
              key={style}
              mr={i % 2 === 0 ? '16px' : 0}
              bg={isSelected ? 'rgba(235, 242, 250, 1)' : 'white'}
              border={isSelected ? '3px solid rgba(120, 149, 255, 1)' : '1px solid rgba(166, 183, 212, 1)'}
              onClick={() => {
                setFieldValue(`widget.widgetPlayButtonStyle`, style)
              }}
            >
              {(() => {
                if (style === PLAY_BUTTON_STYLES.LIGHT) {
                  return (
                    <Flex flexDirection="column" width="auto">
                      <PlayButton
                        animate={values.widget.playButtonAnimation}
                        playButtonColor={'#A6B7D4'}
                        width={60}
                        height={60}
                        viewBox="0 0 60 60"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle cx="30" cy="30" r="28.5" stroke={'#A6B7D4'} stroke-width="3" />
                        <path
                          d="M46.1097 29.2683C47.4431 30.0381 47.4431 31.9626 46.1097 32.7324L24.9451 44.9518C23.6118 45.7216 21.9451 44.7594 21.9451 43.2198L21.9451 18.781C21.9451 17.2414 23.6118 16.2791 24.9451 17.0489L46.1097 29.2683Z"
                          fill={'#A6B7D4'}
                        />
                      </PlayButton>
                      <Label textAlign="center" mt="16px" mb="0px">
                        Light
                      </Label>
                    </Flex>
                  )
                }
                if (style === PLAY_BUTTON_STYLES.BOX) {
                  return (
                    <Flex flexDirection="column" width="auto">
                      <Flex
                        backgroundColor="#A6B7D4"
                        width="60px"
                        height="32px"
                        borderRadius="4px"
                        p="8px"
                        alignItems="center"
                        justifyContent="center"
                      >
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M15.677 7.43164C16.1077 7.68008 16.1077 8.31992 15.677 8.56836L2.93823 15.9164C2.51787 16.1588 2 15.8451 2 15.348V0.652003C2 0.154881 2.51787 -0.158835 2.93823 0.0836401L15.677 7.43164Z"
                            fill={'white'}
                          />
                        </svg>
                      </Flex>
                      <Label textAlign="center" mt="16px" mb="0px">
                        Square
                      </Label>
                    </Flex>
                  )
                }
                if (style === PLAY_BUTTON_STYLES.DURATION) {
                  return (
                    <Flex flexDirection="column" width="auto">
                      <Flex alignItems="center" justifyContent="center" width="auto">
                        <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M11.9673 6.50268C12.3442 6.72007 12.3442 7.27993 11.9673 7.49732L0.820953 13.9268C0.453137 14.139 0 13.8645 0 13.4295V0.570503C0 0.135521 0.453137 -0.13898 0.820954 0.0731851L11.9673 6.50268Z"
                            fill="#A6B7D4"
                          />
                        </svg>
                        <Text color="#A6B7D4" fontWeight="600" ml="8px">
                          0.18
                        </Text>
                      </Flex>
                      <Label textAlign="center" mt="16px" mb="0px">
                        Duration
                      </Label>
                    </Flex>
                  )
                }

                if (style === PLAY_BUTTON_STYLES.FILLED) {
                  return (
                    <Flex flexDirection="column" width="auto">
                      <PlayButton
                        animate={values.widget.playButtonAnimation}
                        playButtonColor={'#A6B7D4'}
                        width={60}
                        height={60}
                        viewBox="0 0 60 60"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle cx="30" cy="30" r="30" fill={'#A6B7D4'} />
                        <path
                          d="M45 28.268C46.3333 29.0378 46.3333 30.9623 45 31.7321L24 43.8564C22.6667 44.6262 21 43.664 21 42.1244L21 17.8756C21 16.336 22.6667 15.3738 24 16.1436L45 28.268Z"
                          fill="white"
                        />
                      </PlayButton>

                      <Label textAlign="center" mt="16px" mb="0px">
                        Filled
                      </Label>
                    </Flex>
                  )
                }
              })()}
            </Flex>
          )
        })}
      </Flex>
      {values.widget.widgetPlayButtonStyle !== PLAY_BUTTON_STYLES.DURATION ? (
        <Flex borderTop="1px solid rgba(237, 242, 247, 1)" borderBottom="1px solid rgba(237, 242, 247, 1)" pt="16px">
          <ColorPickerRow
            label="Color"
            setFieldValue={setFieldValue}
            name="widget.playButtonColor"
            value={values.widget.playButtonColor}
          />
        </Flex>
      ) : null}
      {showPlayButtonSize ? (
        <SideSelect
          label="Play Button Size"
          value={values.widget.widgetPlayButtonSize}
          onChange={(option) => {
            setFieldValue(`widget.widgetPlayButtonSize`, option.value)
          }}
          options={widgetPlayButtonSizeOptions}
          placeholder="Select"
        />
      ) : null}
      {!hidePosition ? (
        <SideSelect
          label="Play Button Position"
          value={values.widget.widgetPlayButtonPosition}
          onChange={(option) => {
            setFieldValue(`widget.widgetPlayButtonPosition`, option.value)
          }}
          options={widgetPlayButtonPositionOptions}
          placeholder="Select"
        />
      ) : null}
      {values.widget.widgetPlayButtonStyle !== PLAY_BUTTON_STYLES.DURATION ? (
        <Flex
          px="24px"
          py="24px"
          justifyContent="space-between"
          borderBottom="1px solid rgba(237, 242, 247, 1)"
          alignItems="center"
        >
          <Label mb="0px">Play Button Animation</Label>
          <ToggleRedGreen
            setSelected={(selected) => {
              setFieldValue('widget.playButtonAnimation', selected)
            }}
            value1={false}
            value2={true}
            selected={values.widget.playButtonAnimation}
          />
        </Flex>
      ) : null}
      {/* {showShare ? (
        <Flex
          px="24px"
          py="24px"
          justifyContent="space-between"
          borderBottom="1px solid rgba(237, 242, 247, 1)"
          alignItems="center"
        >
          <Label mb="0px">Share</Label>
          <ToggleRedGreen
            setSelected={(selected) => {
              setFieldValue('widget.widgetShareButton', selected)
            }}
            value1={false}
            value2={true}
            selected={values.widget.widgetShareButton}
          />
        </Flex>
      ) : null} */}
    </Flex>
  )
}

export default PlayButtonStyle
